import ReactDOM from "react-dom/client";
import { AppContextProvider } from "../AppContextProvider";
import WidgetChildrenWrapper from "../WidgetChildrenWrapper";

export const Widget = ({ config }: any) => {
  return (
    <AppContextProvider>
      <WidgetChildrenWrapper config={config} />
    </AppContextProvider>
  );
};

export function renderWidgetReactComponent(
  container: HTMLElement,
  config: any
) {
  let component;
  const wrapper = document.createElement("div");
  wrapper.id = "maximise-pulse-wrapper";
  container.appendChild(wrapper);
  const root = ReactDOM.createRoot(wrapper);
  root.render(
    <Widget
      config={config}
      ref={(widget: any) => {
        component = widget;
      }}
    />
  );

  return component;
}
